/**
 * Language Configuration
 */

export const languageConfig = {
  defaultLanguage: 'en',
  defaultLocale: 'en-US',

  supportedLanguages: [
    { code: 'en', locale: 'en-US', urlCode: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸', dir: 'ltr', default: true },
    { code: 'ga', locale: 'ga-IE', urlCode: 'ga', name: 'Irish', nativeName: 'Gaeilge', flag: '🇮🇪', dir: 'ltr', default: false },
    { code: 'de', locale: 'de-DE', urlCode: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', dir: 'ltr', default: false },
    { code: 'es', locale: 'es-ES', urlCode: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', dir: 'ltr', default: false },
    { code: 'it', locale: 'it-IT', urlCode: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', dir: 'ltr', default: false },
    { code: 'no', locale: 'no-NO', urlCode: 'no', name: 'Norwegian', nativeName: 'Norsk', flag: '🇳🇴', dir: 'ltr', default: false },
    { code: 'fi', locale: 'fi-FI', urlCode: 'fi', name: 'Finnish', nativeName: 'Suomi', flag: '🇫🇮', dir: 'ltr', default: false },
    { code: 'da', locale: 'da-DK', urlCode: 'da', name: 'Danish', nativeName: 'Dansk', flag: '🇩🇰', dir: 'ltr', default: false },
    { code: 'sv', locale: 'sv-SE', urlCode: 'sv', name: 'Swedish', nativeName: 'Svenska', flag: '🇸🇪', dir: 'ltr', default: false },
    { code: 'fr', locale: 'fr-FR', urlCode: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷', dir: 'ltr', default: false },
    { code: 'pt', locale: 'pt-PT', urlCode: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇵🇹', dir: 'ltr', default: false },
    { code: 'nl', locale: 'nl-NL', urlCode: 'nl', name: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱', dir: 'ltr', default: false },
    { code: 'en-GB', locale: 'en-GB', urlCode: 'uk', name: 'English (UK)', nativeName: 'English (UK)', flag: '🇬🇧', dir: 'ltr', default: false },
    { code: 'en-AU', locale: 'en-AU', urlCode: 'au', name: 'English (Australia)', nativeName: 'English (Australia)', flag: '🇦🇺', dir: 'ltr', default: false },
    { code: 'de-AT', locale: 'de-AT', urlCode: 'at', name: 'German (Austria)', nativeName: 'Deutsch (Österreich)', flag: '🇦🇹', dir: 'ltr', default: false },
  ],

  detectLanguage: () => {
    if (typeof window === 'undefined') return 'en';
    const stored = localStorage.getItem('preferredLanguage');
    if (stored && languageConfig.supportedLanguages.find((l) => l.code === stored)) return stored;
    const browserLang = navigator.language || navigator.userLanguage;
    const langCode = browserLang.split('-')[0];
    const supported = languageConfig.supportedLanguages.find((l) => l.code === langCode);
    return supported ? langCode : languageConfig.defaultLanguage;
  },

  getLanguage: (code) =>
    languageConfig.supportedLanguages.find((l) => l.code === code) ||
    languageConfig.supportedLanguages.find((l) => l.default),

  getLanguageCodes: () => languageConfig.supportedLanguages.map((l) => l.code),
  getUrlCodes: () => languageConfig.supportedLanguages.map((l) => l.urlCode || l.code),

  getLanguageByUrlCode: (urlCode) =>
    languageConfig.supportedLanguages.find((l) => (l.urlCode || l.code) === urlCode),

  getUrlCode: (translationCode) => {
    const lang = languageConfig.getLanguage(translationCode);
    return lang ? lang.urlCode || lang.code : translationCode;
  },

  getTranslationCode: (urlCode) => {
    const lang = languageConfig.getLanguageByUrlCode(urlCode);
    return lang ? lang.code : urlCode;
  },

  isValidUrlCode: (urlCode) =>
    languageConfig.supportedLanguages.some((l) => (l.urlCode || l.code) === urlCode),

  isRTL: (code) => {
    const lang = languageConfig.getLanguage(code);
    return lang ? lang.dir === 'rtl' : false;
  },
};

export default languageConfig;
